<template>
    <div>
        <div class="baojiatitle">
            <h3 color="primary">{{ zidian.zhuangXie }}</h3>
            <div style="margin-left: auto">
                <Button size="small" @click="addTable(zhuangxieModel)">新增表格</Button>
            </div>
        </div>
        <div id="itemList" v-for="(item, row) in itemData.list" :key="row">
            <div class="fenleibiaoti">
                <Tag color="red">装卸按区域，类型，分开计费</Tag>
                <div style="margin-left: auto">
                    <Button size="small" @click='copyTable(item)'>复制表格</Button>
                    <Button size="small" @click='delTable(row)'>删除表格</Button>
                </div>
            </div>
            <div class="priceTable">
                <div>
                    <p>
                        <zhuangxieType :readonly="true">
                        </zhuangxieType>
                    </p>
                    <p>
                        <zhuangxieType :readonly="false" :zxConfig="item.zxConfig" @zxConfig="item.zxConfig = $event">
                        </zhuangxieType>
                    </p>
                </div>
                <div v-for="(x, col) in item.list" :key="col">
                    <p>
                        <Input readonly :border="false" size="small" v-model="x.unit[0]"></Input>
                    </p>
                    <p>
                        <Input :border="false" size="small" v-model="x.price"></Input>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import modelData from "../baojia/modelData";
import zhuangxieType from "../baojia/zhuangxieType.vue";
export default {
    props: ["data",],
    components: { zhuangxieType },
    data() {
        return {
            zidian: modelData.zidian,
            itemData: {},
            zhuangxieModel: modelData.zhuangxieModel
        };
    },
    methods: {
        tt() {
            this.itemData = this.data;
        },
        getVal() {
            return this.itemData;
        },
        //添加表格
        addTable(v) {
            var obj = {
                name: v.name,
                startAdd: v.startAdd,
                endAdd: v.endAdd,
                unit: v.unit,
                list: v.list,
            };
            //list.splice(index, 0, obj);
            this.itemData.list.unshift(JSON.parse(JSON.stringify(obj)));
        },
        copyTable(v) {
            var obj = {
                name: v.name,
                startAdd: v.startAdd,
                endAdd: v.endAdd,
                unit: v.unit,
                list: v.list,
            };
            this.itemData.list.push(JSON.parse(JSON.stringify(obj)));
        },
        delTable(index) {

            this.itemData.list.splice(index, 1);

        },
        reCars(v) {
            var obj = {
                name: v.bind,
                id: v.id,
                useType: v.useType,
            };

            var result = this.dataList.some((item) => {
                if (item.id == obj.id) {
                    return true;
                }
            });
            if (result) {
                this.$Message.error("（" + obj.name + "）已存在");
            } else {
                this.dataList.unshift(obj);
            }
        },
    },
    mounted() {
        this.tt();
    },
    watch: {
        data() {
            this.tt();
        }
    }


};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojias/zhuangXie.vue